import { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import type { Logos } from 'src/context/styling/logos';
import { davidLloydNewLogos } from 'src/context/styling/logos';
import useShouldUseNewLogo from 'src/custom-hooks/use-should-use-new-logo';

const useSiteLogos = (): Logos => {
  const { styling } = use(SiteContext);
  const shouldUseNewLogo = useShouldUseNewLogo();
  return shouldUseNewLogo ? davidLloydNewLogos : styling.logos;
};

export default useSiteLogos;
